import React, { useContext } from "react";
import './ContextMessage.css'
import { FormContext } from "../../app/App";

export default function ContextMessage()
{
    const { show, setShow, showMsg, setShowMsg } = useContext(FormContext);
    if(!showMsg) return <></>

    return (
        <div className="context-message">
            <div className="message">
                <h3 className="message-title">Ваша заявка принята</h3>
                <p className="message-description">Менеджер свяжется с вами в ближайщее время.</p>
            </div>
        </div>
    )
}